module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hostname":"Hostname","TTL":"TTL","type":"Type","apply":"apply","add record":"add record","delete resource record":"delete resource record"},"de":{"hostname":"Hostname","TTL":"TTL","type":"Typ","apply":"übernehmen","add record":"Eintrag hinzufügen","delete resource record":"Resource Eintrag löschen"}}')
  delete Component.options._Ctor
}
